import "../../css/chat/chatwindow.css";
import 'react-block-ui/style.css';

import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, OverlayTrigger, Tooltip, Form } from 'react-bootstrap';
import ChatsService from '../../controllers/ChatController';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation } from "react-i18next";
import Transfer from './transfer';
import SendEmail from './sendemail';
import { closeConversation, changeShowSearch, closeConversationByAgent, toggleAITranslation, updateMessages, setContacts, putOnHold } from '../../redux/interactionsSlice';
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { setSelectedForm } from '../../redux/agentSlice'
import Conversation from '../chat/conversation';
import ContactForm from '../misc/contactform';
import Timeline from '../misc/timeline';
import CloseConfirmation from "./closeconfirmation";
import ConversationSummary from "./conversationsummary";
import MailContact from "../misc/mailContact";
import BlockUi from 'react-block-ui';
import FidelityContactsSelection from '../contacts/fidelitycontactsselection';
import AddressBookFormCall from '../misc/AddressBookFormCall';
import MailHistory from "../misc/mailhistory";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Toastr from "../utils/toastr";
import { useNavigate } from "react-router-dom";
class ChatWindow extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            showTransfer: false,
            showSendEmail: false,
            view: props && props.interaction && props.interaction.channel === "mail" ? "mail" : "conversation",
            showConfirmation: false,
            showSummary: false,
            showHistory: false,
            mail: null,
            newContact: false,
            search: "",
            searchContacts: false
        }

        this.divContent = createRef();
        this.lastMessage = createRef();
        this.inputFile = createRef();
        this.sendButton = createRef();
        this.scrollUpRef = createRef();

        this.messagesRefs = [];

        this.close = this.close.bind(this);
        this.showSearch = this.showSearch.bind(this);
        this.toggleTransferModal = this.toggleTransferModal.bind(this);
        this.toggleSendEmailModal = this.toggleSendEmailModal.bind(this);
        this.conversationClick = this.conversationClick.bind(this);
        this.formClick = this.formClick.bind(this);
        this.contactClick = this.contactClick.bind(this);
        this.timelineClick = this.timelineClick.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);
        this.toggleSummary = this.toggleSummary.bind(this);
        this.mailClick = this.mailClick.bind(this);
        this.toggleAITranslation = this.toggleAITranslation.bind(this);
        this.translate = this.translate.bind(this);
        this.toggleHistory = this.toggleHistory.bind(this);
        this.toggleNewContact = this.toggleNewContact.bind(this);
        this.setSearch = this.setSearch.bind(this);
        this.handleSearchClick = this.handleSearchClick.bind(this);
        this.setSearchContacts = this.setSearchContacts.bind(this);
        this.searchKeyDown = this.searchKeyDown.bind(this);
        this.putOnHold = this.putOnHold.bind(this);
        this.retrieve = this.retrieve.bind(this);
        this.toastrRef = React.createRef();
    }

    componentDidMount() {

        if (this.props.interaction && this.props.interaction.aiTranslation) {
            this.setState({
                loading: true
            });
            this.translate();
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.interaction !== null && (prevProps.interaction === null || (prevProps.interaction !== null && this.props.interaction.id !== prevProps.interaction.id))) {
            let view = this.props.interaction.channel.toLowerCase() === "mail" ? "mail" : "conversation";
            this.setState({ view: view });
            if (this.props.interaction?.aiTranslation) {
                this.setState({
                    loading: true
                });
                this.translate();
            }
        }
    }

    setLoading(value) {
        this.setState({
            loading: value
        })
    }

    close = e => {

        if (this.props.interaction.contactUrl === null || this.props.interaction.contactUrl.trim() === "" || this.props.interaction.contactProcessed === true) {
            this.props.closeConversationByAgent(this.props.interaction.id);
            ChatsService.closeConversation(this.props.interaction.id);
        } else {
            this.toggleConfirmation();
        }
    }

    showSearch = e => {
        this.props.changeShowSearch();
    }

    toggleTransferModal = e => {
        //e.preventDefault();
        this.setState({ showTransfer: !this.state.showTransfer, showOptions: false, showPhone: true });
    }

    toggleSendEmailModal = e => {
        //e.preventDefault();
        this.setState({ showSendEmail: !this.state.showSendEmail });
    }

    conversationClick(e) {
        this.setState({ view: "conversation" });
    }

    formClick(e) {
        this.setState({ view: "form" });
        this.props.setSelectedForm(this.props.interaction.contactUrl);
    }

    contactClick(e) {
        this.setState({ view: "contact" });
    }

    timelineClick(e) {
        this.setState({ view: "timeline" });
    }

    toggleConfirmation = e => {
        //e.preventDefault();
        this.setState({ showConfirmation: !this.state.showConfirmation });
    }

    toggleSummary = e => {
        //e.preventDefault();
        this.setState({ showSummary: !this.state.showSummary });
    }

    mailClick(e) {
        this.setState({ view: "mail" });
    }

    toggleAITranslation = async e => {

        if (!this.props.interaction.aiTranslation) {
            this.setState({
                loading: true
            });
            this.translate();
        }

        this.props.toggleAITranslation();
        ChatsService.toggleAITranslation({ guid: this.props.interaction.guid, lang: window.navigator.language.split("-")[0] });


    }

    translate = async () => {

        var messages = JSON.parse(JSON.stringify(this.props.interaction.messages));

        const translationPromises = messages.map(m => {
            //mesajes de agente con from a null es IVR o AI
            if (m.text && !m.ogText) {
                this.setLoading(true);
                return new Promise((resolve, reject) => {
                    ChatsService.translate({ lang: window.navigator.language.split("-")[0], text: m.text }, data => {

                        m.ogText = m.text;
                        m.text = data;
                        resolve();
                    });
                });
            } else {
                return Promise.resolve();
            }
        });

        await Promise.all(translationPromises);
        this.props.updateMessages(messages);
        this.setState({
            loading: false
        });
    }

    toggleHistory = data => {
        this.setState({ showHistory: !this.state.showHistory, mail: data });
    }

    toggleNewContact = e => {
        e.preventDefault();
        this.props.setContacts([]);
        this.setState({ newContact: true, searchContacts: false });
    }


    handleSearchClick(elem) {
        if (this.state.search !== null && this.state.search.length >= 3) {
            this.setState({ newContact: false, searchContacts: true });
            this.props.setContacts([]);
            ChatsService.findContact({
                tenantId: this.props.tenantId,
                search: this.state.search
            }, this.props.setContacts);
        } else {
            this.toastrRef.current.setType("warning");
            this.toastrRef.current.setMessage(this.props.t("leastchars"));
            this.toastrRef.current.show();
        }
    }

    setSearch(e) {
        e.preventDefault();
        this.setState({
            search: e.target.value
        });
    }

    setSearchContacts(value) {
        this.setState({
            searchContacts: value
        });
    }

    searchKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSearchClick();
        }
    }

    putOnHold(e) {
        e.preventDefault();
        ChatsService.putOnHold({
            guid: this.props.interaction.guid,
            onHold: true
        }, res => {
            if (res !== "ok") {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t(res));
                this.toastrRef.current.show();
            } else {
                this.toastrRef.current.setType("success");
                this.toastrRef.current.setMessage(this.props.t("wassavedsuccessfully"));
                this.toastrRef.current.show();
                this.props.putOnHold(true);
            }
        });

    }

    retrieve(e) {
        e.preventDefault();
        ChatsService.putOnHold({
            guid: this.props.interaction.guid,
            onHold: false
        }, res => {
            if (res !== "ok") {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t(res));
                this.toastrRef.current.show();
            } else {
                this.toastrRef.current.setType("success");
                this.toastrRef.current.setMessage(this.props.t("wassavedsuccessfully"));
                this.toastrRef.current.show();
                this.props.putOnHold(false);
                this.props.navigate("/main/interactions/chat");
            }
        });
    }

    render() {

        return (
            <BlockUi tag="div" blocking={this.state.loading} message={this.props.t("pleasewait")} color="#009ef7">
                {
                    (this.props.interaction) &&
                    <>
                        <Row className='messages-panel postion-relative'>
                            <Col xs={11}>
                                <Row>
                                    {
                                        (this.props.interaction.channel.toLowerCase() !== "mail") &&
                                        <Col className={
                                            "fs-4 pb-3 " +
                                            (this.state.view === "conversation" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                        } onClick={this.conversationClick} >
                                            <FontAwesomeIcon icon={duotone('messages')} /> <span className='chattab'>{this.props.t("conversation")}</span>
                                        </Col>
                                    }
                                    {
                                        (this.props.interaction.channel.toLowerCase() !== "mail" && this.props.interaction.contactUrl !== null) &&
                                        <Col className={
                                            "fs-4 pb-3 " +
                                            (this.state.view === "form" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                        } onClick={this.formClick}>
                                            <FontAwesomeIcon icon={duotone('file-invoice')} /> <span className='chattab'>{this.props.t("form")}</span>
                                        </Col>
                                    }
                                    {
                                        (this.props.interaction.channel.toLowerCase() === "mail") &&
                                        <Col className={
                                            "fs-4 pb-3 " +
                                            (this.state.view === "mail" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                        } onClick={this.mailClick}>
                                            <FontAwesomeIcon icon={duotone('envelope')} /> <span className='chattab'>{this.props.t("email")}</span>
                                        </Col>
                                    }

                                    <Col className={
                                        "fs-4 pb-3 " +
                                        (this.state.view === "contact" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                    } onClick={this.contactClick}>
                                        <FontAwesomeIcon icon={duotone('address-book')} /> <span className='chattab'>{this.props.t("contact")}</span>
                                    </Col>

                                    <Col className={
                                        "fs-4 pb-3 " +
                                        (this.state.view === "timeline" ? "border-bottom border-3 border-primary text-primary" : "cursor-pointer text-muted")
                                    } onClick={this.timelineClick}>
                                        <FontAwesomeIcon icon={duotone('rectangle-history-circle-user')} /> <span className='chattab'>{this.props.t("timeline")}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{ display: (this.state.view === "conversation") ? "inline-block" : "none" }}>
                                        <Conversation />
                                    </Col>
                                    {
                                        (this.props.interaction.contactUrl !== null) &&
                                        <Col style={{ display: (this.state.view === "form") ? "inline-block" : "none" }}>
                                            <ContactForm />
                                        </Col>
                                    }
                                    {
                                        this.state.view === "timeline" &&
                                        <Col style={{ display: (this.state.view === "timeline") ? "inline-block" : "none" }}>
                                            <Timeline interaction={this.props.interaction} />
                                        </Col>
                                    }
                                    <Col style={{ display: (this.state.view === "mail") ? "inline-block" : "none" }}>
                                        <MailContact></MailContact>
                                    </Col>

                                    <Col style={{ display: (this.state.view === "contact") ? "inline-block" : "none" }}>


                                        <Row>
                                            <Col lg={4}>
                                                <Form.Control className='searchinput' style={{ "position": "relative", "top": "8px" }} type="text" placeholder={this.props.t("search")} value={this.state.search} onChange={this.setSearch} onKeyDown={this.searchKeyDown}></Form.Control>
                                            </Col>
                                            <Col lg={2}>
                                                <Button size='sm' variant="primary" onClick={this.handleSearchClick} className="filterbutton ">
                                                    <FontAwesomeIcon icon={solid("magnifying-glass")} />
                                                </Button>
                                                <Button size='sm' variant="primary" onClick={this.toggleNewContact} className="filterbutton ">
                                                    <FontAwesomeIcon icon={faPlus} />
                                                </Button>
                                            </Col>
                                        </Row>


                                        {
                                            ((this.props.interaction.contacts && this.props.interaction.contacts.length === 1 && !this.state.searchContacts) || this.state.newContact) &&
                                            <AddressBookFormCall key={this.props.interaction.id} contacts={this.props.interaction.contacts} mode="chat" />
                                        }

                                        {
                                            (!this.state.newContact && ((this.state.searchContacts && this.props.interaction.contacts.length > 0) ||
                                                (!this.state.searchContacts && this.props.interaction.contacts && this.props.interaction.contacts.length > 1))) &&
                                            <FidelityContactsSelection key={this.props.interaction.id} contacts={this.props.interaction.contacts} setSearchContacts={this.setSearchContacts} mode="chat" />
                                        }

                                        {
                                            (!this.props.interaction.contacts || (this.props.interaction.contacts && this.props.interaction.contacts.length === 0)) && !this.state.newContact &&
                                            <div className='d-flex flex-column flex-center' style={{ position: "relative", top: "50%" }}>
                                                <div className="fs-1 text-center">Fidelity</div>
                                                <div className="fs-4 text-muted text-center">{this.props.t("nocontactsfound")}</div>
                                                <div className='nochatsimg'></div>
                                            </div>
                                        }

                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={1}>
                                <Row className='convactions text-center'>
                                    <Col>
                                        {
                                            (!this.props.interaction.onHold || (this.props.interaction.onHold && this.props.interaction.closed)) &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("close")}
                                                </Tooltip>}>
                                                <Button variant="light-danger" onClick={this.close}><FontAwesomeIcon icon={solid("xmark-large")} /></Button>
                                            </OverlayTrigger>
                                        }

                                        {
                                            "mail" !== this.props.interaction.channel && !this.props.interaction.onHold &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("search2")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.showSearch}><FontAwesomeIcon icon={duotone("magnifying-glass")} /></Button>
                                            </OverlayTrigger>
                                        }
                                        {
                                            !this.props.interaction.onHold &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("transfer")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.toggleTransferModal}><FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} /></Button>
                                            </OverlayTrigger>
                                        }
                                        {
                                            "mail" !== this.props.interaction.channel && !this.props.interaction.onHold &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("sendemail")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.toggleSendEmailModal}><FontAwesomeIcon icon={duotone("envelope")} /></Button>
                                            </OverlayTrigger>
                                        }

                                        {
                                            this.props.aiEnabled && !this.props.interaction.onHold &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("aisummary")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.toggleSummary}><FontAwesomeIcon icon={duotone("microchip-ai")} /></Button>
                                            </OverlayTrigger>
                                        }
                                        {
                                            ("mail" !== this.props.interaction.channel && this.props.aiEnabled && !this.props.interaction.aiTranslation && !this.props.interaction.onHold) &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("enableAITranslate")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.toggleAITranslation}><FontAwesomeIcon icon={duotone("text")} /></Button>
                                            </OverlayTrigger>
                                        }
                                        {
                                            ("mail" !== this.props.interaction.channel && this.props.aiEnabled && this.props.interaction.aiTranslation
                                                && !this.props.interaction.onHold && !this.props.interaction.closed) &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("disableAITranslate")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.toggleAITranslation}><FontAwesomeIcon icon={duotone("text-slash")} /></Button>
                                            </OverlayTrigger>
                                        }
                                        {
                                            ("mail" === this.props.interaction.channel && !this.props.interaction.onHold) &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("emailthread")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={e => { this.toggleHistory(this.props.interaction); }}  ><FontAwesomeIcon icon={duotone("clock-rotate-left")} /></Button>
                                            </OverlayTrigger>
                                        }

                                        {
                                            !this.props.interaction.onHold && !this.props.interaction.closed &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("postpone")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.putOnHold}><FontAwesomeIcon icon={duotone("reply-clock")} /></Button>
                                            </OverlayTrigger>
                                        }

                                        {
                                            (this.props.interaction.onHold && !this.props.interaction.closed) &&
                                            <OverlayTrigger
                                                placement="left"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={<Tooltip style={{ position: "fixed" }}>
                                                    {this.props.t("retrieve")}
                                                </Tooltip>}>
                                                <Button variant="light-primary" onClick={this.retrieve}><FontAwesomeIcon icon={duotone('rotate-left')} /></Button>
                                            </OverlayTrigger>
                                        }
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                        <Transfer show={this.state.showTransfer} toggleModal={this.toggleTransferModal} conversationId={this.props.interaction?.id || -1} channel={this.props.interaction?.channel || ""}></Transfer>
                        <SendEmail show={this.state.showSendEmail} toggleModal={this.toggleSendEmailModal} guid={this.props.interaction != null ? this.props.interaction.guid : -1}></SendEmail>
                        <CloseConfirmation show={this.state.showConfirmation} toggleModal={this.toggleConfirmation} />
                        <ConversationSummary show={this.state.showSummary} toggleModal={this.toggleSummary} guid={this.props.interaction != null ? this.props.interaction.guid : -1} outbound={false}></ConversationSummary>
                        <MailHistory show={this.state.showHistory} toggleModal={this.toggleHistory} mail={this.state.mail}></MailHistory>
                        <Toastr ref={this.toastrRef} />
                    </>
                }
                {
                    (!this.props.interaction) &&
                    <img style={{
                        "margin": "20% 0 0 30%",
                        "opacity": "0.5"
                    }} alt="Logo" src="img/f.png" className="h-50px h-lg-150px" />
                }
            </BlockUi>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        chatUrl: state.parameters.chatUrl,
        LOADING_TYPE: state.parameters.LOADING_TYPE,
        agentName: state.agent.name,
        userId: state.agent.userId,
        showSearch: state.interaction.showSearch,
        interaction: state.interaction.current,
        aiEnabled: state.parameters.aiEnabled,
        tenantId: state.agent.tenantId

    };
};
function WithNavigate(props) {
    let navigate = useNavigate();
    return <ChatWindow {...props} navigate={navigate} />
}
export default compose(connect(mapStateToProps, { changeShowSearch, closeConversation, setSelectedForm, closeConversationByAgent, toggleAITranslation, updateMessages, setContacts, putOnHold }), withTranslation())(WithNavigate);